/**
 * Shown while the signed-in person's profile - and with it their roles - has not loaded. Without
 * it, someone whose profile failed to load simply had fewer options, with nothing to say why
 * (Victor, 5 Oct 2026).
 */
export function ProfileLoadingNote({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="status"
      data-demo="profile-loading-note"
      className="fixed bottom-4 left-1/2 z-[60] flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 shadow-md"
    >
      <span>Your access is still loading, so some options may be missing until it does.</span>
      <button type="button" onClick={onRetry} className="shrink-0 font-medium underline underline-offset-2 hover:text-amber-950">
        Retry
      </button>
    </div>
  )
}
